// extracted by mini-css-extract-plugin
export default {"scroll":"Scroll_scroll__uSW9V","sdb07":"Scroll_sdb07__2i49j"};